
import { lazy } from "react";

const Authentication = lazy(() => import(/* webpackChunkName: "Auth" */ './components/Authentication'));
const authentication = {
    path: "/authentication/:user_id/:access_token/:refresh_token",
    Component: Authentication,
    exact: false,
    innerRoutes: []
};

export default authentication;
